import { Typography } from '@mui/material';
import Checkbox from '../../../../Checkbox';
import type { CheckboxAllSelectedProps } from './types';

const CheckboxAllSelected = ({
  allSelectedCheckbox,
  handleSelectAll,
  isDynamicPageEmpty,
}: CheckboxAllSelectedProps) => {
  return (
    <>
      {!isDynamicPageEmpty ? (
        <>
          <Checkbox
            checked={allSelectedCheckbox}
            onChange={handleSelectAll}
            label="Selecionar todos"
          />
          <Typography fontSize={14}>Selecionar todos</Typography>
        </>
      ) : null}
    </>
  );
};

export default CheckboxAllSelected;
